var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.partition = void 0;
  function partition(items, predicate) {
    const trueItems = [],
      falseItems = [];
    for (const item of items) {
      if (predicate(item)) {
        trueItems.push(item);
      } else {
        falseItems.push(item);
      }
    }
    return [trueItems, falseItems];
  }
  exports.partition = partition;
  return exports;
}